module.exports = {

    error: (message, object = {}) => {
        alert('Ошибка ' + message);
        console.log(message, object);
    },

    notice: (message, object = {}) => {
        console.log(message, object);
    }

};